import {
  OContainer,
  ORow,
  OCol,
  OFooter
} from '@dnvgl-onefoundation/onedesign-react'
import Annotation from 'chartjs-plugin-annotation'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js'
import { SiteHeader, Feedback } from '@/components/layout'
import { HomePage } from '@/components/pages'
import { config } from '@/utils'
import { ValueLabelPlugin } from '@/utils/chartjs'
import { useApp } from '@/hooks'
import AppRoutes from '@/Routes'

const { routes, appFullName, links, authCheckInterval } = config

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Annotation,
  ValueLabelPlugin
)

const App = () => {
  const {
    appRoutes,
    isHomePage,
    currentUser,
    isAuthenticated,
    isLoadingCurrentUser,
    notificationsCount
  } = useApp(routes, authCheckInterval)
  return (
    <>
      <SiteHeader
        routes={appRoutes}
        appName={appFullName}
        logInLink={links.header.logIn}
        logOutLink={links.header.logOut}
        signUpLink={links.header.signUp}
        notificationsLink={links.header.notifications}
        notificationsCount={notificationsCount}
        isLoadingCurrentUser={isLoadingCurrentUser}
        isHomePage={isHomePage}
        currentUser={currentUser}
      />
      {isHomePage ? (
        <HomePage />
      ) : (
        <OContainer main>
          <ORow>
            <OCol col="12" className="mt-2">
              <AppRoutes currentUser={currentUser} />
            </OCol>
          </ORow>
        </OContainer>
      )}
      <OFooter
        small={!isHomePage}
        links={links.footer.big}
        smallLinks={links.footer.big.flatMap(x => x.links)}
        socialMediaLinks={isHomePage ? undefined : []}
        newTab
        className="no-print mt-4"
      />
      {isAuthenticated && <Feedback />}
    </>
  )
}

export { App }
